import i from '~/i18n'

export const labels = {
  title: i.t('rm:campaign.create.ObjectiveBased.setup.title'),
  description: i.t('rm:campaign.create.ObjectiveBased.setup.description')
}
